export default __webpack_public_path__ + "static/media/WorkSans-Bold.f4d3764f.eot";